// src/routes/AdminRoutes.tsx
import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import AdminLogin from "../pages/admin/AdminLogin";
import AdminBriefs from "../pages/admin/AdminBriefs";
import AdminAccount from "../pages/admin/AdminAccount";
import { useAppSelector } from "../app/hooks";

function RequireAdmin({ children }: { children: React.ReactElement }) {
  const location = useLocation();
  const { token, user, hydrated } = useAppSelector((state) => state.auth);

  // Wait for localStorage rehydration before deciding — otherwise a refresh
  // bounces a signed-in admin back to the login screen.
  if (!hydrated) {
    return (
      <div className="min-h-screen bg-itl-cream grid place-items-center">
        <p className="text-[12px] uppercase tracking-[0.2em] text-gray-400">
          Loading…
        </p>
      </div>
    );
  }

  if (!token || user?.role !== "admin") {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return children;
}

export const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />

      <Route
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route path="/" element={<AdminBriefs />} />
        <Route path="/briefs" element={<AdminBriefs />} />
        <Route path="/account" element={<AdminAccount />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
